import Evidence from './Evidence';

export default Evidence;
